import React from "react"
import Container from "../atoms/Container"

function Footer() {
  return (
    <Container>
      <footer className="Footer">
        <p>
          © {new Date().getFullYear()},{" "}Hamish McLean
        </p>
      </footer>
    </Container>
  )
}

export default Footer
